var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"comments"}},[_c('CommentsList',{ref:"list",attrs:{"route-id":_vm.routeId}}),_c('CommentsForm',{attrs:{"route-id":_vm.routeId,"oauth-providers":_vm.dataOauth},on:{"added":_vm.onAddComment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }